import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: '/media',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}

export async function sendQuestion(ctx, data) {
  try {
    const response = await axiosInstance({
      url: '/comments',
      data: data,
      method: 'POST'
    })
    return response
  } catch (e) {
    return e
  }
}


